/* eslint no-console:0 */

import './application/jquery'
import 'jquery-ujs'

import 'unpoly/unpoly'
import 'unpoly/unpoly.css'
import 'unpoly/unpoly-bootstrap4'
import 'unpoly/unpoly-bootstrap4.css'

require('select2/dist/js/select2.full.js')()
require('select2/dist/js/i18n/de')

import 'jquery.tabbable'

import 'blueimp-file-upload'
import 'jquery-ui-sortable-npm'

import 'clipboard/dist/clipboard.min'

import './shared/**/*.js'
import './application/**/*.js'

import './application/stylesheets/fonts.sass'
import './application/stylesheets/application.sass'
import './application/stylesheets/print.sass'
import './application/stylesheets/shared.sass'
import './application/stylesheets/redactor.sass'
import './application/stylesheets/*/**.sass'

import 'redactor'
import 'redactor/langs/de'
import 'redactor/plugins/table/table'
import 'redactor/plugins/alignment/alignment'
